import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Table, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import DemoBanner from '../components/DemoBanner';
import BrandImage from '../components/BrandImage';
import { DICT } from '../utils/dictionary';
import { API_BASE, getAuthHeaders } from '../utils/api'; // Importação do Gateway

// Mock Data Profissional genérico
const DEMO_BONUS_DATA = [
  { titulo: 'Estratégias de Crescimento e Retenção', data_publicacao: '2026-03-05T10:00:00Z', views_30_dias: 154000, valor_bonus: 250.00, status: 'Pago' },
  { titulo: 'Como otimizar seu tempo de produção', data_publicacao: '2026-03-12T14:30:00Z', views_30_dias: 89000, valor_bonus: 100.00, status: 'Pendente' },
  { titulo: 'Análise de Tendências para o Próximo Semestre', data_publicacao: '2026-03-20T09:00:00Z', views_30_dias: 45000, valor_bonus: 50.00, status: 'Pendente' },
];

const MeusBonus = () => {
  const { user, logout, isDemo, token } = useAuth();
  const [bonus, setBonus] = useState([]);
  const [error, setError] = useState('');

  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [ano, setAno] = useState(new Date().getFullYear());
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!user) return;

    const fetchMeusBonus = async () => {
      setError('');

      if (isDemo) {
        setBonus(DEMO_BONUS_DATA);
        const soma = DEMO_BONUS_DATA.reduce((acc, b) => acc + b.valor_bonus, 0);
        setTotal(soma);
        return;
      }

      try {
        // Correção de roteamento aplicando o API Gateway
        const response = await fetch(`${API_BASE}/users/me/bonus?ano=${ano}&mes=${mes}`, {
          headers: getAuthHeaders(token)
        });

        if (response.status === 401) {
          logout();
          return;
        }

        if (!response.ok) throw new Error('Erro ao buscar desempenho.');

        const data = await response.json();
        const dataArray = Array.isArray(data) ? data : [];

        setBonus(dataArray);
        const soma = dataArray.reduce((acc, b) => acc + parseFloat(b.valor_bonus || 0), 0);
        setTotal(soma);

      } catch (err) {
        setError(err.message);
        setBonus([]);
        setTotal(0);
      }
    };

    fetchMeusBonus();
  }, [mes, ano, user, logout, isDemo, token]);

  const currentYear = new Date().getFullYear();
  const anosDisponiveis = Array.from({ length: 6 }).map((_, i) => currentYear - i);

  return (
    <Container fluid className="main-content">
      {isDemo && <DemoBanner />}
      <Row className="align-items-center mb-4">
        <Col xs={12} md={6}>
          <h2 style={{ color: 'var(--brand-secondary)' }}>
            <i className="bi bi-graph-up-arrow me-2" style={{ color: 'var(--brand-primary)' }}></i> Meu Desempenho
          </h2>
        </Col>
        <Col xs={12} md={6} className="text-md-end d-none d-md-block">
          <BrandImage 
            envKey="REACT_APP_BANNER_BONUS"
            defaultAsset="/client_assets/aero_athos.png" 
            alt="Identidade Visual Desempenho"
            style={{ maxWidth: 150, height: 'auto' }} 
          />
        </Col>
      </Row>

      <div className="card border-0 shadow-sm mb-4 p-3">
        <Row className="align-items-center">
          <Col md={3} className="mb-3 mb-md-0">
            <Form.Label className="text-muted small mb-1">Mês</Form.Label>
            <Form.Select value={mes} onChange={e => setMes(Number(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString('pt-BR', { month: 'long' }).toUpperCase()}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={3} className="mb-3 mb-md-0">
            <Form.Label className="text-muted small mb-1">Ano</Form.Label>
            <Form.Select value={ano} onChange={e => setAno(Number(e.target.value))}>
              {anosDisponiveis.map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6} className="text-md-end mt-3 mt-md-0">
            <div className="p-3 rounded" style={{ backgroundColor: 'var(--brand-bg-light)', border: '1px solid var(--brand-primary)' }}>
              <h5 className="mb-0" style={{ color: 'var(--brand-secondary)' }}>
                {DICT.REWARD} Projetado: <strong style={{ color: 'var(--brand-primary)', fontSize: '1.4rem' }}>
                  {total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </strong>
              </h5>
            </div>
          </Col>
        </Row>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {/* Tabela — desktop */}
      <div className="card border-0 shadow-sm d-none d-md-block overflow-hidden">
        <div className="table-responsive">
          <Table hover className="align-middle mb-0">
            <thead style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-text-on-dark)' }}>
              <tr>
                <th className="border-0"><i className="bi bi-file-earmark-text me-2"></i>{DICT.CONTENT_SING}</th>
                <th className="border-0">Data de Entrega</th>
                <th className="border-0">{DICT.METRIC_PLUR} (30 dias)</th>
                <th className="border-0">{DICT.REWARD} Calculado</th>
                <th className="border-0">Status</th>
              </tr>
            </thead>
            <tbody>
              {bonus.map((item, i) => (
                <tr key={i} className="border-bottom">
                  <td className="fw-bold">{item.titulo}</td>
                  <td>{new Date(item.data_publicacao).toLocaleDateString('pt-BR')}</td>
                  <td>{(item.views_30_dias || 0).toLocaleString('pt-BR')}</td>
                  <td className="fw-bold" style={{ color: 'var(--brand-primary)' }}>
                    {parseFloat(item.valor_bonus || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </td>
                  <td>
                    <span className={`badge bg-${item.status.toLowerCase() === 'pago' ? 'success' : 'warning'}`}>
                      {item.status.toUpperCase()}
                    </span>
                  </td>
                </tr>
              ))}
              {bonus.length === 0 && !error && (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-muted">
                    <i className="bi bi-inbox fs-3 d-block mb-2"></i>
                    Nenhum desempenho registrado neste período.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Cards — mobile */}
      <div className="d-md-none">
        {bonus.length === 0 && !error ? (
          <div className="text-center py-5 text-muted">
            <i className="bi bi-inbox fs-2 d-block mb-2"></i>
            Nenhum desempenho registrado neste período.
          </div>
        ) : bonus.map((item, i) => (
          <div key={i} className="card border-0 shadow-sm mb-3 p-3">
            <div className="fw-bold mb-2" style={{ fontSize: '0.95rem', lineHeight: 1.3 }}>{item.titulo}</div>
            <div className="d-flex justify-content-between align-items-center mb-1 small text-muted">
              <span><i className="bi bi-calendar3 me-1"></i>{new Date(item.data_publicacao).toLocaleDateString('pt-BR')}</span>
              <span><i className="bi bi-eye me-1"></i>{(item.views_30_dias || 0).toLocaleString('pt-BR')} {DICT.METRIC_PLUR}</span>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <span className="fw-bold" style={{ color: 'var(--brand-primary)', fontSize: '1.1rem' }}>
                {parseFloat(item.valor_bonus || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </span>
              <span className={`badge bg-${item.status.toLowerCase() === 'pago' ? 'success' : 'warning'}`}>
                {item.status.toUpperCase()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default MeusBonus;